<script setup lang="ts">
const { showLogoMarkAsPlaceholder } = useTenantConfig()
</script>

<template>
  <div class="from-secondary-500/20 to-primary-500/20 flex size-full items-center justify-center bg-gradient-to-r">
    <PublicLogoMark v-if="showLogoMarkAsPlaceholder" class="max-h-14" />
  </div>
</template>
